import type { DiffResult } from './diff-types.js';

export type DiffSummary = {
  created: number;
  updated: number;
  deleted: number;
  unchanged: number;
};

export function summarize(diff: DiffResult): DiffSummary {
  let created = 0;
  let updated = 0;
  let deleted = 0;
  let unchanged = 0;
  for (const op of diff.ops) {
    if (op.kind === 'create') created++;
    else if (op.kind === 'delete') deleted++;
    else if (op.kind === 'update') {
      if (op.changes.configChanged) updated++;
      if (!op.changes.configChanged) unchanged++;
    }
  }
  return { created, updated, deleted, unchanged };
}

export function hasAnyChange(diff: DiffResult): boolean {
  if (diff.ops.some((op) => op.kind !== 'update' || op.changes.configChanged)) return true;
  if (diff.edgeChanges) return true;
  return Object.keys(diff.workflowFieldChanges).length > 0;
}
